import { render, staticRenderFns } from "./jumpConfig.vue?vue&type=template&id=b4a1018a&scoped=true"
import script from "./jumpConfig.vue?vue&type=script&lang=js"
export * from "./jumpConfig.vue?vue&type=script&lang=js"
import style0 from "./jumpConfig.vue?vue&type=style&index=0&id=b4a1018a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a1018a",
  null
  
)

export default component.exports